import axios from "axios";

// deploy http://981e7478-2274-4910-a841-2e6e38cfd341.pub.instances.scw.cloud/api
// https://a1e34f34-fd6c-4bf7-b8b3-4528eeb499e6.pub.instances.scw.cloud/api
// local http://localhost:8080/api

export default axios.create({
 baseURL: "https://a1e34f34-fd6c-4bf7-b8b3-4528eeb499e6.pub.instances.scw.cloud/api",
   //baseURL: "http://localhost:8080/api",
  headers: {
    "Content-type": "application/json"
  }
});
